import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import {Trans} from "react-i18next";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyle = makeStyles(({
    root: {
      width: '80vw'
    },
    progressContainer: {
        border: '1px solid black',
        padding: '2px',
        backgroundColor: 'white'
    },
    progressBar: {
        backgroundColor: 'black',
        height: '6px',
    }
}))

const UploadProgressPopup = ({totalProgress, retrying}) => {
    const classes = useStyle();


    return <Dialog open={true} classes={{paper: classes.root}}>
        <DialogTitle>
            <Trans>Upload status</Trans>
        </DialogTitle>
        <DialogContent>
            {retrying && <p>
                <Trans>Retrying...</Trans>
            </p>}

            <div className={classes.progressContainer}>
                 <div className={classes.progressBar} style={{width: (totalProgress * 100) + '%'}} />
            </div>
        </DialogContent>
    </Dialog>
}

export default UploadProgressPopup;